<template>
  <div
    v-if="$store.getters.loadingApp !== 1"
    class="leads"
  >
    <v-card
      flat
      class="pa-4 d-flex flex-row flex-wrap justify-center"
    >
      <v-radio-group
        v-model="scopeLeads"
        row
        class="mt-0"
        @change="getClients(scopeLeads)"
      >
        <v-radio
          label="Ongoing"
          value="ongoing"
          class="my-0 py-0"
        />
        <v-radio
          label="No Conversion"
          value="noResponse"
          class="my-0 py-0"
        />
      </v-radio-group>
    </v-card>
    <v-data-table
      :headers="headersLeads"
      :items="leads"
      sort-by="autoContact"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [itemsPerPage]
      }"
      :search="searchLeads"
    >
      <template v-slot:top>
        <v-toolbar
          flat
          color="white"
        >
          <div class="d-flex flex-row flex-wrap justify-center">
            <v-card flat>
              <v-text-field
                v-model="searchLeads"
                append-icon="$vuetify.icons.icon_mdi_magnify"
                :label="'Search ' + `${ leads.length }` + ' lead(s)'"
                single-line
                hide-details
                style="width: 300px"
                clearable
              />
            </v-card>
          </div>
          <v-spacer />

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                color="ppc_pink"
                dark
                small
                absolute
                right
                fab
                v-on="on"
                @click="dialogAddLead = !dialogAddLead"
              >
                <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
              </v-btn>
            </template>
            <span>Add a new lead</span>
          </v-tooltip>
        </v-toolbar>
      </template>

      <template v-slot:[`item.full_name`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-row align-center">
              <v-btn 
                x-small
                fab
                v-bind="attrs"
                class="mr-3" 
                v-on="on"
                @click="goClient(item.id)"
              >
                <v-icon>mdi-arrow-up-bold</v-icon>
              </v-btn>
              <strong>{{ item.full_name }}</strong>
            </div>
          </template>
          <span>Go to Client</span>
        </v-tooltip>
      </template>

      <template v-slot:[`item.id`]="{ item }">
        {{ formattedDate(item.id) }}
      </template>

      <template v-slot:[`item.gender`]="{ item }">
        <v-icon
          v-if="`${item.gender}` === 'Male'"
          small
          color="ppc_darkgreen"
        >
          fa-male
        </v-icon>
        <v-icon
          v-else-if="`${item.gender}` === 'Female'"
          small
          color="ppc_darkgreen"
        >
          fa-female
        </v-icon>
        <v-icon
          v-else
          small
          color="ppc_darkgreen"
        >
          fa-genderless
        </v-icon>
      </template>

      <template v-slot:[`item.onlyEnglishCourses`]="{ item }">
        <div v-if="`${item.onlyEnglishCourses}` === '1'">
          <v-icon small>
            $vuetify.icons.icon_english
          </v-icon>
        </div>
      </template>

      <template v-slot:[`item.start_first`]="{ item }">
        {{ formattedDate(item.start_first) }}
      </template>

      <template v-slot:[`item.statusClientId`]="{ item }">
        <v-chip
          small
          :color="`${getStatus(item.statusClientId).color}`"
          text-color="white"
          v-html="`${getStatus(item.statusClientId).name}`"
        />
      </template>

      <template v-slot:[`item.autoContact`]="{ item }">
        <v-chip
          v-if="`${item.autoContact}` !== 'null' && (formattedDate(`${item.autoContact}`, 'date') <= nowDate)"
          small
          color="ppc_pink"
          v-html="formattedDate(`${item.autoContact}`, 'date')"
        />
        <v-chip
          v-else-if="`${item.autoContact}` !== 'null'"
          small
          color="ppc_darkgreen"
          v-html="formattedDate(`${item.autoContact}`, 'date')"
        />
        <v-chip
          v-else
          small
          color="orange"
        >
          not set
        </v-chip>
      </template>

      <!-- <template v-slot:[`item.edit`]="{ item }"> 
        <v-btn 
          @click="goClient(item.id)"
          icon
        >
          <v-icon
            small
            class="mr-2"
          >
            $vuetify.icons.icon_mdi_pencil
          </v-icon>
        </v-btn>
      </template> -->
    </v-data-table>

    <v-dialog
      v-model="dialogAddLead"
      max-width="500px"
    >
      <v-card style="height: 550px">
        <v-card-title>
          <span class="headline">New lead</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="formAddLead"
            v-model="addLeadValid"
          >
            <v-container>
              <v-radio-group
                v-model="typeClient"
                cols="12"
                column
                class="mt-0"
                label="Select type of Client"
              >
                <v-radio
                  label="Client (default)"
                  value="Client"
                  class="my-0 py-0"
                />
                <v-radio
                  label="Group without Names"
                  value="groupWithoutNames"
                  class="my-0 py-0"
                />
              </v-radio-group>
              <v-row v-if="typeClient === 'Client'">
                <v-col
                  cols="auto"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model.trim="first_name"
                    label="First name"
                    prepend-icon="$vuetify.icons.icon_mdi_smart_card ppc_darkgreen--text" 
                    validate-on-blur
                    :error-messages="errorMessageNames"
                    :rules="inputRulesName"
                  />
                </v-col>
                <v-spacer />
                <v-col
                  cols="auto"
                  sm="6"
                  md="6"
                >
                  <v-text-field
                    v-model.trim="last_name"
                    label="Last name"
                    prepend-icon="$vuetify.icons.icon_mdi_smart_card-outline ppc_darkgreen--text" 
                    validate-on-blur
                    :error-messages="errorMessageNames"
                    :rules="inputRulesName"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="12"
                >
                  Select a source (can be changed later) or an agency. 
                  <v-select
                    v-model="sourceId"
                    :items="$store.state.itemsSources"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Source"
                    single-line
                    prepend-icon="fab fa-sourcetree ppc_darkgreen--text"
                    validate-on-blur
                    @change="agencyId=null"
                  />
                  <v-select
                    v-model="agencyId"
                    :items="$store.state.available_agencies"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ auto: true }"
                    label="Agency"
                    single-line
                    prepend-icon="fab fa-sourcetree ppc_darkgreen--text"
                    validate-on-blur
                    @change="sourceId=null"
                  />
                </v-col>
              </v-row>
              <div v-if="typeClient !== 'Client'">
                Only use this when: you are not able to get their names, no need of knowing their personal preferences, no individual pickups, no need of sending personal emails, no extra individual services, no fairwell message, no after marketing, etc.
                <v-text-field
                  v-model.trim="last_name"
                  label="Name of the group"
                  prepend-icon="$vuetify.icons.icon_mdi_smart_card-outline ppc_darkgreen--text" 
                  validate-on-blur
                  :error-messages="errorMessageNames"
                  :rules="inputRulesName"
                />
                <v-text-field
                  v-model="numberPeople"
                  label="amount of people"
                  type="number"
                  validate-on-blur
                  :rules="inputRulesReq"
                />
                <v-select
                  v-model="agencyId"
                  :items="$store.state.available_agencies"
                  item-text="name"
                  item-value="id"
                  :menu-props="{ auto: true }"
                  label="Agency"
                  single-line
                  prepend-icon="fab fa-sourcetree ppc_darkgreen--text"
                  validate-on-blur
                  :rules="inputRulesReq"
                  @change="sourceId=null"
                />
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            @click="dialogAddLead = !dialogAddLead"
          >
            Cancel
          </v-btn>
          <v-btn
            color="ppc_darkgreen darken-1"
            text
            :loading="loading"
            :disabled="!addLeadValid"
            @click="addLead()"
          >
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import inputRules from '../mixins/inputRules';
import formattedDate from '../mixins/formattedDate';
import dayjs from 'dayjs';
import { createUniqueId } from '@/utils/createUniqueId';
export default {

  mixins: [inputRules, formattedDate],
  data() {
    return {
      nowDate: null,
      arrivals: null,
      dialogAddLead: false,
      loading: false,
      itemsNationality: [],
      itemsSource: [],
      errorMessageNames: '',
      first_name: '',
      last_name: '',
      sourceId: 1,
      agencyId: null,
      leads: [],
      scopeLeads: 'ongoing',
      headersLeads: [],
      addLeadValid: true,
      arrayUpload: [],
      typeClient: 'Client',
      numberPeople: null,
      searchLeads: '',
    }
  },
  computed: {
    successMessage () {
      return this.$store.getters.successMessage
    },
    itemsPerPage () {
        return this.$store.getters.itemsPerPage
    },
  },
  
  watch: {
    successMessage: function () {
      if (this.successMessage !== "") {
        this.alertSuccessMessage = true;
      }
    },
  },
  beforeCreate () {
    this.$store.dispatch('setLoadingApp', 1)
  },
  created () {
    dayjs.locale("en");
    this.initialize();
  },
  methods: {
    async initialize () {
      this.$store.dispatch('breadcrumbs', ['Leads']);
      this.getClients('ongoing');
      this.nowDate = this.formattedDate(new Date(), 'date');
      this.$store.dispatch('setLoadingApp', 0)
    },

    goClient(id) {
      this.$store.dispatch('setLoadingApp', 1);
      this.$router.push({ name: 'Client', params: { id: id } })
    },

    getStatus(id) {
      return this.$store.state.statusClients.filter((select_item) => {
        return select_item.id === id;
      })[0];
    },

    async addLead () {
      if (this.$refs.formAddLead.validate()) {
        // check existance
        // exactly same name
        this.searchResults = await this.$store.dispatch('searchClient', this.first_name + ' ' + this.last_name)
        if (this.searchResults.length === 1) {
          this.$store.dispatch('warningMessage', 'Client already exsists!');
          this.goClient(this.searchResults[0].id);
        } else {
          const id = createUniqueId('cusco');
          var salesContact = null;
          if (this.agencyId) {
            let tmp = this.$store.state.available_agencies.filter((select_item) => {
              return select_item.id === this.agencyId
            })
            salesContact = tmp[0].salesContact_id;
            var agencyName = tmp[0].name;
          } else {
            let tmp = this.$store.state.uid;
            let user = this.$store.state.users.filter((select_item) => {
              return select_item.id === tmp;
            })
            salesContact = user[0].contact_id;
          }
          if (this.typeClient === 'Client') {
            var lead = {
              id: id,
              first_name: this.first_name,
              last_name: this.last_name,
              gender: 'X',
              pickup_type: 'To be confirmed',
              source_id: this.sourceId,
              agency_id: this.agencyId,
              numberPeople: null,
              food_preference: 'Not known',
              pets_preference: 'Not known',
              salesContact: salesContact,
              ignore_welcome_email: 0,
              ignore_thank_you_email: 0,
              ignore_security_deposit: 0,
              statusFixed: 0,
              statusPassport: 0,
              statusCV: 0,
              last_changed_by: this.$store.state.uid,
            }
          } else {
            lead = {
              id: id,
              first_name: 'Group - ' + agencyName + '(' + this.numberPeople + ') ',
              last_name: this.last_name,
              gender: 'X',
              pickup_type: 'Flight',
              source_id: null,
              agency_id: this.agencyId,
              number_people: this.numberPeople,
              salesContact: salesContact,
              ignore_welcome_email: 0,
              ignore_thank_you_email: 0,
              ignore_security_deposit: 0,
              statusFixed: 0,
              statusPassport: 0,
              statusCV: 0,
              last_changed_by: this.$store.state.uid,
            }
          }
          
          this.$refs.formAddLead.reset();
          this.$store.dispatch('setLoadingApp', 1);
          let payload = {
              client: lead,
              applications: null,
              services: null,
              radioGroups: null,
              radioOptions: null,
              options: null,
              resources: null,
          };
          await this.$store.dispatch('insertUpdateMainItems', payload);
          console.log('lead added');
          // this.first_name = '';
          // this.last_name = '';
          // this.email = null;
          // this.sourceId = null;
          // this.agencyId = null;
          // this.dialogAddLead = false;
          this.goClient(id);
        }
      }
    },

    async getClients(scopeLeads) {
      if (scopeLeads === 'ongoing') {
        this.leads = await this.$store.dispatch('getLeads');
        this.headersLeads = [
          { text: 'Full Name', align: 'start', value: 'full_name' },
          { text: 'Created', value: 'id', width: "150px" },
          { text: 'Email', value: 'email' },
          { text: 'Gender', value: 'gender', width: "100px", sortable: false},
          { text: 'Nationality', value: 'nationality' },
          { text: 'Source/Agency', value: 'source' },
          { text: 'Only English', value: 'onlyEnglishCourses' },
          { text: 'Sales Contact', value: 'salesContactName' },
          { text: 'Start', value: 'start_first', width: "150px"},
          { text: 'Status', value: 'statusClientId' },
          { text: 'Comments', value: 'comments' },
          // { text: 'Next Contact', value: 'autoContact' }
        ];
      } else {
        this.leads = await this.$store.dispatch('getLeadsNoResponse');
        this.headersLeads = [
          { text: 'Full Name', align: 'start', value: 'full_name' },
          { text: 'Created', value: 'id', width: "150px" },
          { text: 'Email', value: 'email' },
          { text: 'Gender', value: 'gender', width: "100px", sortable: false},
          { text: 'Nationality', value: 'nationality' },
          { text: 'Source/Agency', value: 'source' },
          { text: 'Only English', value: 'onlyEnglishCourses' },
          { text: 'Sales Contact', value: 'salesContactName' },
          { text: 'Start', value: 'start_first', width: "150px"},
          { text: 'Status', value: 'statusClientId' },
          { text: 'Comments', value: 'comments' },
        ];
      }
      for (let index = 0; index < this.leads.length; index++) {

        const contactId = this.leads[index].salesContact;
        let contact = this.$store.state.contacts.filter((select_item) => {
          return select_item.id === contactId;
        })
        if (contact.length > 0) {
          this.leads[index].salesContactName = contact[0].name;
        }

        const nationalityId = this.leads[index].nationality_id;
        let nationality = this.$store.state.itemsNationality.filter((select_item) => {
          return select_item.id === nationalityId;
        })
        if (nationality.length > 0) {
          this.leads[index].nationality = nationality[0].nationality;
        }

        const agencyId = this.leads[index].agency_id;
        let agency = this.$store.state.available_agencies.filter((select_item) => {
          return select_item.id === agencyId;
        })
        if (agency.length > 0) {
          this.leads[index].source = agency[0].name;
        } else {
          const sourceId = this.leads[index].source_id;
          let source = this.$store.state.itemsSources.filter((select_item) => {
            return select_item.id === sourceId;
          })
          if (source.length > 0) {
            this.leads[index].source = source[0].name;
          }
        }
      }
    },
  },
}
</script>